(() => {
  const desktopLogo = document.querySelector('.site-nav > .site-nav__logo');
  const mobileLogo = document.querySelector('.site-header__mobile > .site-nav__logo--mobile');
  if (!desktopLogo && !mobileLogo) return;

  const floatingLogo = (desktopLogo || mobileLogo).cloneNode(true);
  floatingLogo.className = 'aeliza-floating-symbol';
  floatingLogo.removeAttribute('id');
  floatingLogo.removeAttribute('aria-hidden');
  floatingLogo.removeAttribute('tabindex');
  floatingLogo.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
  document.body.appendChild(floatingLogo);

  let activeSource = null;
  let frame = 0;

  const update = () => {
    frame = 0;
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    const source = isMobile ? mobileLogo : desktopLogo;
    if (!source) return;

    if (activeSource !== source) {
      desktopLogo?.classList.remove('aeliza-floating-source-hidden');
      mobileLogo?.classList.remove('aeliza-floating-source-hidden');
      source.classList.add('aeliza-floating-source-hidden');
      activeSource = source;
    }

    const rect = source.getBoundingClientRect();
    const width = isMobile ? 47 : (rect.width || 40);
    const top = Math.max(12, rect.top);

    floatingLogo.style.setProperty('--aeliza-floating-logo-top', top + 'px');
    floatingLogo.style.setProperty('--aeliza-floating-logo-width', width + 'px');
    floatingLogo.style.setProperty('--aeliza-floating-logo-height', width + 'px');
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
})();
